import {lazy} from "react";

export const SettingsCallApiPage = lazy(() => import("./settings_call_api"));